import { useFormControls, UseFormControlsParams } from '../hooks/useFormControls';

export type FormControls<InputValues extends object, OutputValues extends object = InputValues> = Omit<
    ReturnType<typeof useFormControls<InputValues, OutputValues>>,
    'renderFormContent'
>;

export type FormProps<
    InputValues extends object,
    OutputValues extends object = InputValues,
> = UseFormControlsParams<InputValues> & {
    children: ((controls: FormControls<InputValues, OutputValues>) => React.ReactNode) | React.ReactNode;
};

/**
 * @description This component should cover most use cases of forms implementation in the application.
 * For Dialog's forms please use `useFormControls` hook if required.
 */
export const Form = <InputValues extends object, OutputValues extends object = InputValues>({
    children,
    ...other
}: FormProps<InputValues, OutputValues>) => {
    const { renderFormContent, ...controls } = useFormControls(other);

    return renderFormContent(typeof children === 'function' ? children(controls) : children);
};
